module.exports = __webpack_public_path__ + "img/icon.a7e0efa2.png";